import { LastVideosPlaylistData } from '@/pages/video/playlists/[canais]';
import Breadcrumb from '@/components/Layout/Breadcrumb';

export default function PlaylistHeader({ titulo, descricao, breadcrumb }: LastVideosPlaylistData['data']) {
  return (
    <section className="relative flex w-full content-center justify-center [background:linear-gradient(90deg,#0086FF_0%,_#2ECEFF_100%)]">
      <div className="w-full max-w-[calc(100%-2rem)] px-0 py-10 tablet:max-w-[83.33%] [&_a]:text-mglGray50 [&_div]:before:text-mglGray50">
        <Breadcrumb breadcrumbList={breadcrumb} />
        <h1 className="mb-3 text-4xl font-medium text-mglGray50">{titulo}</h1>
        {descricao && <p className="text-xs text-mglGray50">{descricao}</p>}
      </div>
    </section>
  );
}
